import React, { useState, useEffect } from 'react';
import { Drawer, Form, Input, Select, Button } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { updateCompany, fetchCompanies } from '../../../redux/Company/actions';
import { fetchCountries } from '../../../redux/Country/actions';

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export const EditCompany = ({ item, onRefresh }) => {
  const dispatch = useDispatch();
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [form] = Form.useForm();
  const countries = useSelector((state) => state.countries.countries || []);

  useEffect(() => {
    dispatch(fetchCountries());
  }, [dispatch]);

  const showDrawer = () => {
    onFill();
    setDrawerVisible(true);
  };

  const onFill = () => {
    form.setFieldsValue({
      ...item,
      country: item.country?._id,
    });
  };

  const hideDrawerOk = () => {
    form.submit();
  };

  const formOnFinish = (values) => {
    dispatch(updateCompany(item._id, values)).then(() => {
      onRefresh();
    });
    form.resetFields();
    setDrawerVisible(false);
  };

  const hideDrawerCancel = () => {
    setDrawerVisible(false);
    form.resetFields();
  };

  return (
    <>
      <Button type="primary" onClick={showDrawer}>
        Edit
      </Button>
      <Drawer
        title="Edit Company"
        visible={drawerVisible}
        closable={true}
        onClose={hideDrawerCancel}
        footer={
          <div style={{ textAlign: 'right' }}>
            <Button onClick={hideDrawerCancel} style={{ marginRight: 8 }}>
              Cancel
            </Button>
            <Button onClick={hideDrawerOk} type="primary">
              Submit
            </Button>
          </div>
        }
        width="70%"
        bodyStyle={{ padding: '16px', overflow: 'auto' }}
      >
        <Form
          {...layout}
          form={form}
          onFinish={formOnFinish}
        >
          <Form.Item
            label="Name"
            name="name"
            rules={[{ required: true, message: 'Please enter the company name!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Address"
            name="address"
            rules={[{ required: true, message: 'Please enter the address!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="URL"
            name="url"
            rules={[{ required: true, message: 'Please enter the company URL!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[{ required: true, message: 'Please enter a description!' }]}
          >
            <Input.TextArea />
          </Form.Item>
          <Form.Item
            label="Country"
            name="country"
          >
            <Select placeholder="Select a country">
              {countries.map((country) => (
                <Select.Option key={country._id} value={country._id}>
                  {country.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Drawer>
    </>
  );
};

export default EditCompany;
